import { RoleCard } from '@components/RoleCard';
import { RequestType } from '@features/FindSpecialist/store/findSpecialistService';
import { Nullable } from '@utils/util.types';
import { useTranslation } from 'react-i18next';

export const ConsultationTypeSelector = ({
	selectedType,
	onSelect,
}: {
	selectedType: Nullable<RequestType>;
	onSelect: (type: RequestType) => void;
}) => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col sm:flex-row gap-[20px] items-center justify-center">
			<RoleCard
				className="w-full"
				role="ONE_TIME"
				title={t('findSpecialistPage.oneTimeConsultation')}
				selectedRole={selectedType}
				onSelect={() => onSelect('ONE_TIME')}
			/>
			<RoleCard
				className="w-full"
				role="SEASONAL"
				title={t('findSpecialistPage.seasonalConsultation')}
				selectedRole={selectedType}
				onSelect={() => onSelect('SEASONAL')}
			/>
		</div>
	);
};
